import { ReferenceField, TextField } from "react-admin";
import * as React from "react";
import { SourceVwUser } from "../../../Constants/Source";
import PropTypes from "prop-types";

const UpdatedByField = ({ source = "updatedBy", record, label, link }) => {
  let by: number = Number(record[source]);
  let isNan: boolean = isNaN(by);
  return isNan ? (
    <TextField source={source} label={label} />
  ) : (
    <ReferenceField label={label} source={source} reference={SourceVwUser} record={record} link={link}>
      <TextField source="name" />
    </ReferenceField>
  );
};

UpdatedByField.propTypes = {
  record: PropTypes.any,
  label: PropTypes.string,
  link: PropTypes.bool,
  source: PropTypes.string,
};

export default UpdatedByField;
